import { render, staticRenderFns } from "./PersonMultiStepForm.vue?vue&type=template&id=7445df90&"
import script from "./PersonMultiStepForm.vue?vue&type=script&lang=js&"
export * from "./PersonMultiStepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports